import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPage } from "../../api/pages";
import { Container } from "reactstrap";
import "./styles.css";
import SmallLoader from "../../helpers/Common/SmallLoader";
import NotFound from "../../helpers/Common/NotFound";
import MetaTags from "../../helpers/Common/MetaTags";
import { getMetaConfig } from "../../helpers/Common/metaConfig";
import { generateCmsPageSchema } from "../../helpers/Common/cmsPageSchema";

const CmsPage = () => {
  const { page } = useParams();
  const [details, setDetails] = useState({ content: "", title: "" });
  const [loading, setLoading] = useState(true);

  console.log("URL PARAM:", page);
  console.log("DECODED:", decodeURIComponent(page));

  const cmsPageSchema = generateCmsPageSchema(details);

  const cmsPageMeta = getMetaConfig('cmsPage', {
    title: details?.title || 'Page',
    description: details?.metaDescription || 'Informative content and resources from JobSeekers Page.',
    keywords: details?.metaKeyword || 'jobseekers page information',
    ogTitle: details?.title || 'Webvi',
    ogDescription: details?.metaDescription || 'Access helpful content and resources.',
    canonicalUrl: `${window.location.origin}/page/${details?.urlSlug || page}`,
    webPage: cmsPageSchema
  });

 useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  if (!page) {
    console.log("❌ Page param missing");
    return;
  }

  setLoading(true);

  console.log("👉 Raw URL slug:", page);

 getPage()
  .then((json) => {
    console.log("👉 Full API Response:", json);

    const decodedSlug = decodeURIComponent(page);
    console.log("👉 Decoded Slug:", decodedSlug);

    const apiData = json?.data?.data || [];

    console.log(
      "👉 All API Slugs:",
      apiData.map((item) => item.urlSlug)
    );

    const matchedPage = apiData.find(
      (item) => item.urlSlug === decodedSlug
    );

    console.log("👉 Matched Page:", matchedPage);

    if (matchedPage) {
      setDetails({
        title: matchedPage.title,
        content: matchedPage.content,
        metaDescription: matchedPage.metaDescription,
        metaKeyword: matchedPage.metaKeyword,
        urlSlug: matchedPage.urlSlug,
      });
    } else {
      console.log("❌ No matching page found");
      setDetails({ content: "", title: "" });
    }
  })
  .catch((error) => {
    console.log("❌ API ERROR:", error);
  })
  .finally(() => {
    setLoading(false);
  });
}, [page]);

  let content =
    details?.content && details?.title ? (
      <div className="content-sec">
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: details.content }} />
        </div>
      </div>
    ) : null;

  return (
    <>
      <MetaTags {...cmsPageMeta} />
      <Container>
        <div className="cmspage-sec">
          {loading ? (
            <SmallLoader />
          ) : details?.content && details?.title ? (
            content
          ) : (
            <NotFound />
          )}
        </div>
      </Container>
    </>
  );
};

export default CmsPage;
